import React from "react";

import { IMatchState } from "./reduce";

interface IGlobalUserInfo {
  userId: string;
  username: string;
}

interface IGlobalMatchContext {
  state: IMatchState;
  dispatch: any;
}

export const UserInfo = React.createContext<IGlobalUserInfo>({
  userId: "",
  username: "",
});

export const MatchContext = React.createContext<IGlobalMatchContext>(null);
